import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/future/image';

const StorageWorks = (props: any) => {
  const title = props?.howWorksTitle;
  const data = props?.howWorksData;
  return (
    <section className="sv-working-of-cubeit">
      <div className="container">
        <h2 className="section-heading">{title}</h2>
        <div className="sv-moving-storage-cards">
          <div className="row justify-content-center">
            {data &&
              data?.length &&
              data?.map((item: any) => {
                return (
                  <div key={item?.id} className="col-lg-4 col-md-4 col-sm-12">
                    <div className="card sv-info-card sv-card-equal-height mb-4">
                      <div className="card-header">
                        <div className="card-logo-img">
                          <Image
                            src={item?.Thumbnail?.data?.attributes?.url}
                            alt={item?.Thumbnail?.data?.attributes?.url}
                            width="61"
                            height="61"
                          />
                        </div>

                        <div className="card-title sv-card-titles">
                          {item?.Title}
                        </div>
                      </div>
                      <div
                        className="card-body"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(item?.Description),
                        }}
                      ></div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorageWorks;
